export interface PageRequest {
    page?: number;
    pageSize?: number;
    filters?: string;
    sorts?: string;
}

export interface PageState {
    page: number;
    pageSize: number;
    totalItems?: number;
    totalPages?: number;
}

export interface PaginatedResult<TItem, TRaw = any> {
    items: TItem[];
    page: PageState;
    raw: TRaw;
}

export function buildPageQuery(params: Record<string, unknown> | PageRequest = {}): Record<string, unknown> {
    const q: Record<string, unknown> = {};
    for (const [k, v] of Object.entries(params)) {
        if (v !== undefined && v !== null && v !== '') q[k] = v;
    }
    return q;
}

export function toPaginatedResult<TItem, TDto = TItem, TRaw extends { data?: TDto[] | null; pagination?: any } = any>(
    raw: TRaw,
    map: (dto: TDto) => TItem
): PaginatedResult<TItem, TRaw> {
    const data = (raw?.data ?? []) as TDto[];
    const items = data.map(map);
    const p = raw?.pagination ?? {} as any;
    const page: PageState = {
        page: p.currentPage ?? p.page ?? 1,
        pageSize: p.pageSize ?? 10,
        totalItems: p.totalItems,
        totalPages: p.totalPages,
    };
    return { items, page, raw };
}
